import { render, staticRenderFns } from "./GraficoCircular.vue?vue&type=template&id=7addc37e"
import script from "./GraficoCircular.vue?vue&type=script&lang=js"
export * from "./GraficoCircular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7addc37e')) {
      api.createRecord('7addc37e', component.options)
    } else {
      api.reload('7addc37e', component.options)
    }
    module.hot.accept("./GraficoCircular.vue?vue&type=template&id=7addc37e", function () {
      api.rerender('7addc37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardReportNMV/components/generic/GraficoCircular.vue"
export default component.exports